import axios from "axios";
import md5 from "md5";

//import bcrypt from 'bcryptjs';
//import xxhash from 'xxhashjs';

const getDefaultState = () => {
  return {
    dadosLogin: {
      usuario: "",
      senha: "",
    },
    usuariosRelacionados: [],
    usuarioLogado: null,
    meusDados: null,
  };
};

const usuarioStore = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setUsuarioLogado(state, user) {
      state.usuarioLogado = user;
    },
    setMeusDados(state, meusDados) {
      state.meusDados = meusDados;
    },
  },

  actions: {
    async login(context) {

      const user = context.state.dadosLogin.usuario;

      const response = await axios.get(
        `/base/hash-password?usuario=${user}`,
        {
          headers: {
            "Cache-Control": "no-store",
            Pragma: "no-cache",
          },          
        }
      );

      var pass = context.state.dadosLogin.senha;

      if (response.data.success) {        
        if(response.data.data.hash_password){                    
          pass = md5(context.state.dadosLogin.senha);
        }       
                
        return await axios.post(
          "/nutricao-animal/usuario/login",
          JSON.stringify({
            usuario: context.state.dadosLogin.usuario,
            senha: pass
          })
        );
      
      }else{
        return response
      }
    },
    async getMeusDados(context) {
      context.commit("setMeusDados", null);
      await axios.get("/nutricao-animal/usuario/meus-dados").then((res) => {
        if (res.data.success) {
          context.commit("setMeusDados", res.data.data);
        }
      });
    },
  },
  getters: {},
};

export default usuarioStore;
